import { createFileRoute } from '@tanstack/react-router'

import { ConversationsPage } from '#/modules/communication/conversations-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/conversations')({
  component: ConversationsPage,
  validateSearch: validateListSearch,
})
